var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "custom-form-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_DataFill"),
        width: "1300px",
        "show-close": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _vm.innerVisible
        ? _c("ai-custom-page-data-view", {
            attrs: {
              "form-config": _vm.formConfig,
              "page-parts": _vm.pageParts,
              debug: false,
              readonly: _vm.readonly,
              "job-uuid": _vm.derivedJob.uuid,
              job: _vm.derivedJob,
              jobs: _vm.jobs,
              "tenant-instructions": _vm.tenantInstructions
            },
            on: {
              saveSuccess: function($event) {
                return _vm.$emit("callback")
              },
              close: function($event) {
                _vm.innerVisible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }